import React from 'react';
import { CheckIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  className?: string;
};
export function CheckItem({
  children,
  className = ''
}: CheckItemProps) {
  return <li className={`flex items-start gap-1.5 ${className}`} data-id="element-38" data-mp="2746931bmdycf">
      <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-check" strokeWidth={3} aria-hidden data-id="element-39" data-mp="2c2hlnjtaumyc" />
      <span data-id="element-40" data-mp="2c04xgowy7gcu">{children}</span>
    </li>;
}